import React from 'react'
import { Query } from 'react-apollo'
import REDIRECTED_RESOURCE_QUERY from './redirect.query'
import { Loader, withNotifier } from 'stylist'
import { Redirect } from 'react-router-dom'
import { compose } from 'recompose'
import withQueryParams from 'components/withQueryParams'

const RedirectHandler = ({ applicationId, sourceId, sourceType, notify }) => (
  <Query
    query={REDIRECTED_RESOURCE_QUERY}
    variables={{ applicationId, sourceId, sourceType }}
  >
    {({ loading, data, error, ...rest }) => {
      if (loading) {
        return <Loader />
      }

      if (!data || error) {
        notify('warning', 'Resource not found')
        return <Redirect to={'/'} />
      }

      const { id, type } = data.redirectedResource
      return <Redirect to={`/${type}/${id}`} />
    }}
  </Query>
)

const RouteRedirect = ({ notify, query }) => {
  return (
    <RedirectHandler
      applicationId={query.get('application_id')}
      sourceId={query.get('source_id')}
      sourceType={query.get('source_type')}
      notify={notify}
    />
  )
}

export default compose(
  withQueryParams,
  withNotifier
)(RouteRedirect)



// WEBPACK FOOTER //
// ./src/routes/redirect.js